module.exports = __webpack_public_path__ + "img/silo.860efc09.webp";